import axios from "axios";
const API = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL + "/api"
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

API.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Gọi API refresh (dùng token cũ trong header)
                const refreshRes = await axios.post(
                    process.env.REACT_APP_API_BASE_URL + "/api/refresh",
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );

                const newToken = refreshRes.data.access_token;

                localStorage.setItem("access_token", newToken);

                originalRequest.headers.Authorization = "Bearer " + newToken;

                // Retry lại request ban đầu
                return API(originalRequest);
            } catch (err) {
                // Nếu refresh thất bại → logout
                localStorage.clear();
                window.location.href = "/login?error=LoginError";
                return Promise.reject(err);
            }
        }

        return Promise.reject(error);
    }
);

export default API;
